<div class="dialog-shell">
  <div class="dialog-header">
    <div>
      <p class="eyebrow">Meeting Setup</p>
      <h2>Schedule Meeting</h2>
      <p class="subhead">Create a calendar-ready session, pick the live room mode, and push it straight to invited staff.</p>
    </div>
    <button mat-icon-button type="button" (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="form" class="dialog-body">
    <div class="dialog-section hero-strip">
      <div>
        <span>Mode</span>
        <strong>{{ selectedMode }}</strong>
      </div>
      <div>
        <span>Invitees</span>
        <strong>{{ selectedCount }}</strong>
      </div>
      <div>
        <span>Calendar</span>
        <strong>Staff visible</strong>
      </div>
    </div>

    <div class="dialog-section mode-alert" *ngIf="shouldRecommendAudio">
      <mat-icon>campaign</mat-icon>
      <div>
        <strong>Audio-first recommended</strong>
        <small>Meetings with more than {{ audioFirstThreshold }} invitees are more stable when they start as audio-first.</small>
      </div>
    </div>

    <div class="dialog-section room-mode-grid">
      <button
        type="button"
        class="room-mode-card"
        *ngFor="let mode of roomModes"
        [class.active]="selectedMode === mode.value"
        (click)="chooseRoomMode(mode.value)"
      >
        <mat-icon>{{ mode.icon }}</mat-icon>
        <div>
          <strong>{{ mode.title }}</strong>
          <small>{{ mode.blurb }}</small>
        </div>
      </button>
    </div>

    <div class="dialog-section form-section">
      <div class="section-heading">
        <strong>Meeting Details</strong>
        <small>Define the schedule, room setup, and invite list.</small>
      </div>

      <div class="grid">
      <mat-form-field appearance="outline" class="wide">
        <mat-label>Meeting title</mat-label>
        <input matInput formControlName="title" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="wide">
        <mat-label>Description</mat-label>
        <textarea matInput rows="3" formControlName="description"></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Date</mat-label>
        <input matInput type="date" formControlName="meetingDate" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Start time</mat-label>
        <input matInput type="time" formControlName="startTime" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>End time</mat-label>
        <input matInput type="time" formControlName="endTime" />
        <mat-error *ngIf="form.get('endTime')?.errors?.['invalidRange']">End time must be after start time.</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Meeting room type</mat-label>
        <mat-select formControlName="roomType">
          <mat-option value="Video">Video</mat-option>
          <mat-option value="Audio">Audio</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Room name</mat-label>
        <input matInput formControlName="roomName" placeholder="Optional" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="wide">
        <mat-label>Meeting link</mat-label>
        <input matInput formControlName="meetingLink" placeholder="Optional join URL" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="wide">
        <mat-label>Invite staff</mat-label>
        <mat-select formControlName="attendeeStaffIds" multiple (selectionChange)="onAttendeesChanged()">
          <mat-option *ngFor="let staff of data.staffOptions" [value]="staff.staffId">
            {{ staff.fullName }} <span *ngIf="staff.department">· {{ staff.department }}</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
      </div>
    </div>

    <div class="dialog-section attendee-preview" *ngIf="selectedCount">
      <div class="preview-head">
        <strong>Attendee Preview</strong>
        <span>{{ selectedCount }} selected</span>
      </div>
      <div class="preview-list">
        <div class="preview-chip" *ngFor="let attendee of attendeePreview()">
          <span class="avatar">{{ (attendee.fullName || '?').charAt(0) }}</span>
          <div>
            <strong>{{ attendee.fullName }}</strong>
            <small>{{ attendee.department || attendee.position || 'Staff' }}</small>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div class="dialog-actions">
    <button mat-stroked-button type="button" (click)="dialogRef.close()">Cancel</button>
    <button mat-flat-button color="primary" type="button" (click)="save()">Create Meeting</button>
  </div>
</div>
